<template>
  <div>
    <h2 class="content-block-title">{{ title }}</h2>

    <DxForm
      v-if="!loading"
      class="dx-card content-block"
      :form-data="formData"
      :read-only="true" 
      label-mode="static"
      :show-colon-after-label="true"
    >

    <DxGroupItem
      :col-count="3"
      css-class="form-group"
    >
      
      <!-- <DxSimpleItem data-field="checked_at" label="Checked At"  data-type="date" format="yyyy-MM-dd HH:mm:ss" /> -->

    <DxSimpleItem
      data-field="checked_at"
      label="Checked At"
      editor-type="dxDateBox"
      data-type="date"
      :editor-options="{ readOnly: true, displayFormat: 'yyyy-MM-dd HH:mm:ss' }"
    />


      <DxSimpleItem data-field="installed" label="Installed" />
      <DxSimpleItem data-field="valid" label="Valid" />


    </DxGroupItem>

    <DxGroupItem
      :col-count="2"
      css-class="form-group"
    >   
      <DxSimpleItem data-field="has_warnings" label="Has Warnings" />
       <DxSimpleItem
        v-if="formData.warnings.length"
        label="Warnings"
        :editor-options="{ value: formData.warnings.join('\n'), height: 100, readOnly: true }"
        editor-type="dxTextArea"        
      />


    </DxGroupItem>

    <DxGroupItem
      :col-count="2"
      css-class="form-group"
    >    

      <DxSimpleItem data-field="has_notices" label="Has Notices" />

      <DxSimpleItem
        v-if="formData.notices.length"
        label="Notices"
        :editor-options="{ value: formData.notices.join('\n'), height: 100, readOnly: true }"
        editor-type="dxTextArea"
        :col-span="2"
      />


    </DxGroupItem>

    <DxGroupItem
      :col-count="2"
      css-class="form-group"
    >    
      <DxSimpleItem data-field="has_error" label="Has Error" />


      <DxSimpleItem data-field="error" label="Error" />


    </DxGroupItem>

    <DxGroupItem
      :col-count="2"
      css-class="form-group"
    >    

      <DxSimpleItem
        :col-span="2"
        css-class="validation-warning"
        :editor-options="{ ...validationMessage, value: formData.validation_message }"
        data-field="validation_message"
        editor-type="dxTextArea"
      />

    </DxGroupItem>

    </DxForm>

    <div v-if="loading" class="loading-overlay">
      <DxLoadIndicator :height="60" :width="60" />
    </div>
  </div>
</template>

<script>
import { DxForm, DxSimpleItem, DxGroupItem } from 'devextreme-vue/form';
import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
import axios from 'axios';

export default {
    name: 'HAProxyConfigValidation',
    components: {
        DxForm,
        DxSimpleItem,
        DxGroupItem,
        DxLoadIndicator
    },
    data() {
        return {
            title: 'HAProxy Configuration Validation',
            formData: {},
            loading: true,
            validationMessage: {
                height: 140,
                autoResizeEnabled: true,
                readOnly: true
            }
        };
    },
    mounted() {
        this.loadValidation();
    },
    methods: {
        // async loadValidation() {
        //     try {
        //         // const response = await fetch('/internal/haproxy/config/validate');
        //         const response = await axios.get('/api/internal/haproxy/config/validate');

        //         // const data = await response.json();
        //         const data = await response.data;

        //         // Ensure checked_at is a Date object if valid
        //         if (data.checked_at) {
        //             const parsedDate = new Date(data.checked_at);
        //             data.checked_at = isNaN(parsedDate) ? null : parsedDate;
        //         }

        //         this.formData = data;
        //     } catch (error) {
        //         console.error('Failed to load validation data:', error);
        //     } finally {
        //         this.loading = false;
        //     }
        // }

      async loadValidation() {
        try {
          const response = await axios.get('/api/internal/haproxy/config/validate');
          const data = response.data;

          // Normalize fields
          data.checked_at = data.checked_at ? new Date(data.checked_at) : null;
          data.warnings = Array.isArray(data.warnings) ? data.warnings : [];
          data.notices = Array.isArray(data.notices) ? data.notices : [];
          data.error = typeof data.error === 'string' ? data.error : '';

          this.formData = data;
        } catch (error) {
          console.error('Failed to load validation data:', error);
        } finally {
          this.loading = false;
        }
      }


    }
};



</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
}

.dx-card.content-block {
  padding: 20px;
  border-radius: 4px;
  box-sizing: border-box;
}

.validation-warning .dx-texteditor {
  background-color: rgba(255, 165, 0, 0.1);
  border-color: #ffa500 !important;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
}

.validation-warning .dx-label {
  color: #ffa500;
  font-weight: 500;
}
</style>
